<template>
  <CommonPages class="rankings-page" :class="['rankings-conatiner']" headerTheme="dark"
    titlePrefix="Rank">

    <div class="rankings-page__container">
      <!-- 排名内容区域 -->
      <div class="rankings-page__content">
        <!-- 排名标签导航 -->
        <div class="rankings-page__tabs" ref="tabContainer"
          :class="{'rankings-page__tabs--mobile': deviceType === 'mobile'}">
          <div class="rankings-page__tab"
            :class="{'rankings-page__tab--active': activeTab === 'weekly'}"
            @click="selectTab('weekly')" data-tab="weekly">
            <div class="rankings-page__tab-icon-wrapper">
              <img src="@/assets/category-Biography.svg" class="rankings-page__tab-icon" alt="icon">
            </div>
            <div class="rankings-page__tab-text">Weekly Hot Books</div>
          </div>
          <div class="rankings-page__tab"
            :class="{'rankings-page__tab--active': activeTab === 'monthly'}"
            @click="selectTab('monthly')" data-tab="monthly">
            <div class="rankings-page__tab-icon-wrapper">
              <img src="@/assets/category-Self-help.svg" class="rankings-page__tab-icon" alt="icon">
            </div>
            <div class="rankings-page__tab-text">Monthly Hot Books</div>
          </div>
          <div class="rankings-page__tab"
            :class="{'rankings-page__tab--active': activeTab === 'yearly'}"
            @click="selectTab('yearly')" data-tab="yearly">
            <div class="rankings-page__tab-icon-wrapper">
              <img src="@/assets/category-Romance.svg" class="rankings-page__tab-icon" alt="icon">
            </div>
            <div class="rankings-page__tab-text">Yearly Hot Books</div>
          </div>
        </div>

        <AdComponent v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.ranking_top"
          ref="ads-ranking-top" class="pc_padding m_padding" :ads="adsensConfig?.ranking_top"
          :showDebug="showDebug" />

        <!-- 排名列表展示区域 -->
        <div class="rankings-page__list-container">
          <!-- 列表加载中状态 -->
          <div v-if="loading" class="rankings-page__loading">
            <div class="loader"></div>
            <p>Loading...</p>
          </div>

          <!-- 列表内容 -->
          <div v-else-if="paginatedBooks.length > 0" class="rankings-page__list">
            <template v-for="(book, index) in paginatedBooks">
              <div class="rankings-page__book-item" :key="'rank-book-'+book.id"
                @click="goToDetail(book)">
                <div class="rankings-page__book-content">
                  <div class="rankings-page__book-info">
                    <div class="rankings-page__book-title-group">
                      <h3 class="rankings-page__book-title">{{ book.title }}</h3>
                      <div class="rankings-page__book-author">By {{ book.author }}</div>
                    </div>

                    <div class="rankings-page__book-tags">
                      <div class="rankings-page__book-tag rankings-page__book-tag--rating">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12"
                          viewBox="0 0 12 12" fill="none">
                          <path
                            d="M6 0C5.80302 0 5.63472 0.0961647 5.5078 0.213572C5.38088 0.33098 5.27903 0.47454 5.18487 0.635508C4.99654 0.957443 4.83682 1.3563 4.68095 1.76327C4.52508 2.17024 4.37566 2.58362 4.23302 2.91318C4.09037 3.24274 3.92546 3.48566 3.88535 3.51613C3.84523 3.54659 3.57302 3.63634 3.22908 3.67631C2.88513 3.71627 2.4613 3.73567 2.04284 3.76486C1.62438 3.79405 1.21293 3.8321 0.861812 3.91983C0.686252 3.9637 0.523469 4.01877 0.377421 4.10866C0.231373 4.19855 0.091925 4.33478 0.0310553 4.5306C-0.0298147 4.72641 0.00641869 4.92552 0.0740254 5.08797C0.141632 5.25042 0.241827 5.3939 0.359191 5.53725C0.593919 5.82395 0.905579 6.10823 1.22771 6.38893C1.54984 6.66964 1.88211 6.94619 2.1379 7.18983C2.39368 7.43347 2.56269 7.67186 2.57801 7.72116C2.59334 7.77045 2.59064 8.06882 2.52072 8.42308C2.4508 8.77734 2.33831 9.20397 2.23555 9.62898C2.1328 10.054 2.03896 10.4744 2.01029 10.8505C1.99595 11.0386 1.99576 11.2167 2.03242 11.3897C2.06908 11.5626 2.15172 11.7453 2.31108 11.8663C2.47044 11.9873 2.66192 12.0122 2.83063 11.9952C2.99933 11.9782 3.16004 11.9243 3.32674 11.852C3.66013 11.7072 4.01478 11.4825 4.36974 11.249C4.7247 11.0155 5.07816 10.7729 5.37889 10.594C5.67962 10.415 5.95042 10.3205 6 10.3205C6.04958 10.3205 6.32039 10.415 6.62112 10.594C6.92184 10.7729 7.27531 11.0155 7.63026 11.249C7.98522 11.4825 8.33987 11.7072 8.67327 11.852C8.83997 11.9243 9.00067 11.9782 9.16938 11.9952C9.33808 12.0122 9.52957 11.9873 9.68892 11.8663C9.84828 11.7453 9.93092 11.5626 9.96758 11.3897C10.0042 11.2167 10.0041 11.0386 9.98971 10.8505C9.96103 10.4744 9.8672 10.054 9.76445 9.62898C9.66169 9.20397 9.5492 8.77734 9.47928 8.42308C9.40936 8.06882 9.40666 7.77045 9.42199 7.72116C9.43731 7.67186 9.60632 7.43347 9.86211 7.18983C10.1179 6.94619 10.4502 6.66964 10.7723 6.38893C11.0944 6.10823 11.4061 5.82395 11.6408 5.53725C11.7582 5.3939 11.8584 5.25042 11.926 5.08797C11.9936 4.92552 12.0298 4.72641 11.9689 4.5306C11.9081 4.33478 11.7686 4.19855 11.6226 4.10866"
                            fill="#0088FF" />
                        </svg>
                        <span>{{ book.rating || '4.5' }}</span>
                      </div>
                      <div class="rankings-page__book-tag">{{ book.category }}</div>
                    </div>
                  </div>

                  <div class="rankings-page__book-cover-container">
                    <img :src="book.coverImage" :alt="book.title" class="rankings-page__book-cover"
                      @error="$event.target.src = require('@/assets/book_default_1.jpg')">
                    <div class="rankings-page__rank-badge" v-if="index < 3">
                      <span>Top {{ index + 1 + (currentPage - 1) * itemsPerPage }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <AdComponent
                v-if="deviceType == 'mobile' && $global.isObjectNotEmpty(adsensConfig) && adsensConfig?.ranking && shouldInsertAdDeviece('ranking',index) != -1"
                :key="`ad_rank_mobile_${index}`" :ref="'ads-rank-insert-' + index" class="m_padding"
                :ads="adsensConfig?.ranking?.[shouldInsertAdDeviece('ranking',index)]"
                :showDebug="showDebug" />
              <AdComponent
                v-if="deviceType != 'mobile' && $global.isObjectNotEmpty(adsensConfig) && adsensConfig?.ranking && shouldInsertAdDeviece('rankingPC',index) != -1"
                :key="`ad_rank_pc_${index}`" :ref="'ads-rank-insert-pc-' + index"
                class="pc_padding" :ads="adsensConfig?.ranking?.[shouldInsertAdDeviece('rankingPC',index)]"
                :showDebug="showDebug" />
            </template>
          </div>

          <!-- 空状态 -->
          <div v-else class="rankings-page__empty">
            <div class="rankings-page__empty-text">No ranking data available</div>
          </div>

          <!-- 分页控制器 -->
          <div v-if="totalPages > 1" class="category-pagination">
            <img src="@/assets/vector-left.svg" alt="Previous" @click="prevPage"
              :class="{'disabled': currentPage === 1}" class="category-pagination__arrow">
            <div class="category-pagination__dots">
              <span v-for="page in totalPages" :key="page" class="category-pagination__dot"
                :class="{'active': page === currentPage}" @click="goToPage(page)"></span>
            </div>
            <img src="@/assets/vector-right.svg" alt="Next" @click="nextPage"
              :class="{'disabled': currentPage === totalPages}" class="category-pagination__arrow">
          </div>
        </div>

      </div>
    </div>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import AdComponent from '@/pages/components/AdComponent.vue'
import { mapGetters } from 'vuex'
import CommonPages from '@/pages/components/page_common.vue'
import '@/css/rankings.scss'

export default {
  name: 'Rankings',
  components: {
    CommonPages,
    AdComponent,
  },
  mixins: [common, adMixin, adTrackingMixin],
  computed: {
    ...mapGetters([
      'deviceType',
      "adsensConfig",
      'adPosConfig',
      'showDebug'
    ]),
    // 当前选中标签对应的图书列表
    currentBooks () {
      return this.booksByTab[this.activeTab] || []
    },
    // 总页数
    totalPages () {
      return Math.ceil(this.currentBooks.length / this.itemsPerPage)
    },
    // 当前页显示的图书
    paginatedBooks () {
      const start = (this.currentPage - 1) * this.itemsPerPage
      const end = start + this.itemsPerPage
      return this.currentBooks.slice(start, end)
    }
  },
  data () {
    return {
      activeTab: 'weekly',
      loading: false,
      currentPage: 1, // 当前页码
      itemsPerPage: 24, // 每页显示数量
      // 修改为与API返回格式匹配的键
      rankingTabs: ['weekly', 'monthly', 'yearly'],
      // 修改booksByTab对象结构与rankingTabs保持一致
      booksByTab: {
        weekly: [],
        monthly: [],
        yearly: []
      },
      isFirstVisible: true,
      isLastVisible: false
    }
  },
  mounted () {
    // 初始加载时检查滚动状态并滚动到选中的Tab
    this.$nextTick(() => {
      this.checkScrollPosition();
      window.addEventListener('resize', this.checkScrollPosition);
      this.scrollActiveTabIntoView();
    });
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.checkScrollPosition);
  },
  watch: {
    '$route.query.tab': {
      immediate: true,
      handler (newTab) {
        if (newTab && this.rankingTabs.includes(newTab)) {
          this.activeTab = newTab;
          this.currentPage = 1; // 切换时重置页码
          
          // 如果该分类数据还未加载，则尝试加载
          if (this.booksByTab[newTab] && this.booksByTab[newTab].length === 0) {
            this.fetchRankingsByType(newTab);
          }
          
          this.$nextTick(() => {
            this.scrollActiveTabIntoView();
          });
        }
      }
    }
  },
  created () {
    this.fetchRankings()
  },
  methods: {
    // 将当前选中的标签滚动到可视区域
    scrollActiveTabIntoView () {
      const container = this.$refs.tabContainer;
      if (!container || this.deviceType !== 'mobile') return;

      // 强制禁用平滑滚动
      container.style.scrollBehavior = 'auto';

      // 获取当前选中的标签元素
      const activeElement = container.querySelector(`.rankings-page__tab--active`);
      if (!activeElement) return;

      // 使用 getBoundingClientRect 进行稳健计算
      const containerRect = container.getBoundingClientRect();
      const activeRect = activeElement.getBoundingClientRect();

      // 计算滚动位置，使选中元素居中
      const relativeLeft = activeRect.left - containerRect.left;
      let scrollPosition = container.scrollLeft + relativeLeft - (containerRect.width / 2) + (activeRect.width / 2);

      // 确保滚动不超出边界
      scrollPosition = Math.max(0, Math.min(scrollPosition, container.scrollWidth - container.clientWidth));

      // 直接设置scrollLeft
      container.scrollLeft = scrollPosition;

      // 更新状态
      this.checkScrollPosition();
    },

    checkScrollPosition () {
      const container = this.$refs.tabContainer;
      if (container && this.deviceType === 'mobile') {
        const tolerance = 5;
        this.isFirstVisible = container.scrollLeft <= tolerance;
        const scrollEnd = container.scrollWidth - container.clientWidth;
        this.isLastVisible = container.scrollLeft >= (scrollEnd - tolerance);
      }
    },

    shouldInsertAdDeviece (pos, index) {
      // 判断是否应该插入广告的位置
      const position = index + 1;
      const adIndex = this.adPosConfig?.[pos]?.indexOf(position) ?? -1;
      return adIndex;
    },

    // 选择排行榜标签
    selectTab (tab) {
      if (this.activeTab === tab) return;
      
      // 通过路由跳转更新 URL 中的 tab 参数，watcher 会处理后续逻辑
      this.$router.push({
        query: {
          ...this.$route.query,
          tab: tab
        }
      }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error(err);
        }
      });
    },

    // 分页方法
    nextPage () {
      if (this.currentPage < this.totalPages) {
        this.currentPage++
      }
    },
    prevPage () {
      if (this.currentPage > 1) {
        this.currentPage--
      }
    },
    goToPage (page) {
      this.currentPage = page
    },

    // 获取所有排行榜数据
    async fetchRankings () {
      this.loading = true

      try {
        // 调用API获取排行榜数据
        const response = await this.$global.server.getRankList();

        if (response.data && response.data.result) {
          // 新的API返回格式为 {"result": {"MONTH": [], "YEAR": [], "WEEK": []}}
          const rankData = response.data.result;

          // 处理每个榜单类型的数据
          if (rankData.WEEK && Array.isArray(rankData.WEEK)) {
            this.booksByTab.weekly = this.processRankData(rankData.WEEK);
          }

          if (rankData.MONTH && Array.isArray(rankData.MONTH)) {
            this.booksByTab.monthly = this.processRankData(rankData.MONTH);
          }

          if (rankData.YEAR && Array.isArray(rankData.YEAR)) {
            this.booksByTab.yearly = this.processRankData(rankData.YEAR);
          }
        } else {
          console.warn('API returned ranking data format does not match expectations');
        }
      } catch (error) {
        console.error('Failed to fetch ranking data:', error);
      } finally {
        this.loading = false;
      }
    },

    // 根据类型获取排行榜数据
    async fetchRankingsByType (type) {
      // 如果数据已存在，不再重新获取
      if (this.booksByTab[type] && this.booksByTab[type].length > 0) {
        return;
      }

      this.loading = true;

      try {
        // 调用API获取排行榜数据
        const response = await this.$global.server.getRankList();

        if (response.data && response.data.result) {
          const rankData = response.data.result;

          if (type === 'weekly' && rankData.WEEK && Array.isArray(rankData.WEEK)) {
            this.booksByTab.weekly = this.processRankData(rankData.WEEK);
          }
          if (type === 'monthly' && rankData.MONTH && Array.isArray(rankData.MONTH)) {
            this.booksByTab.monthly = this.processRankData(rankData.MONTH);
          }
          if (type === 'yearly' && rankData.YEAR && Array.isArray(rankData.YEAR)) {
            this.booksByTab.yearly = this.processRankData(rankData.YEAR);
          }
        }
      } catch (error) {
        console.error(`Failed to fetch ${type} ranking data:`, error);
      } finally {
        this.loading = false;
      }
    },

    // 处理API返回的排行榜数据
    processRankData (booksData) {
      return booksData.map(book => ({
        id: book.id,
        title: book.novelName || 'Unknown Title',
        author: book.novelAuthorName || 'Unknown Author',
        category: book.novelType || 'Fiction',
        coverImage: book.bigImg || require('@/assets/book_default_1.jpg'),
        rating: book.novelScoreStr || '0',
        novelId: book.novelId || '',
        description: book.novelStoryIntro || 'No description available.',
      }));
    },

    // 跳转到书籍详情页
    goToDetail (book) {
      // 构建URL - 路由格式：/:categories/:novelName/:id
      const categoryParam = book.category ? book.category.toLowerCase().replace(/\s+/g, '-') : 'fiction';
      const titleParam = book.novelId ? book.novelId : book.title.toLowerCase().replace(/\s+/g, '-');
      const idParam = book.id;

      // 跳转到书籍详情页
      this.$router.push(`/${categoryParam}/${titleParam}/${idParam}`);
    }
  }
}
</script>

<style lang="scss">
// 样式已移至 @/css/rankings.scss
</style>
